export class PopPositionAndArrow {
    public top: string;
    public left: string;
    public arrowClass: string;
    constructor() {}
}
